import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect () {
    this.hue = Number(localStorage.getItem("hue") || 200)
    this.interval = setInterval(this.nextHue.bind(this), 2000)
  }

  disconnect () {
    clearInterval(this.interval)
  }

  nextHue () {
    this.hue = (this.hue + 1) % 360
    this.element.style.setProperty("--brand-primary-hue", this.hue)
    localStorage.setItem("hue", this.hue)
  }
}
